
import React from 'react';
import { FlowRender } from "../flow-render";
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";
import { Text } from "../prm/text";
import { Name } from "../prm/name";
import {CLIENT_SIGNER} from "../onboarding-utils";

const MK_YES_NO = (id, label, fake=RADIO_SINGLE_RANDOM_VALUE) => {
  const result = new RadioButton(new Name(id, label), [
    new Name("yes", "Yes"),
    new Name("no", "No"),
  ], [], fake);
  result.do_checkbox = true;
  return result;
}

const employee_bd = MK_YES_NO("employee_bd",
  "Are you an employee of this broker-dealer?", null);
/*const EMPLOYEE_GROUP = {
  yes_no: employee_bd,
  labels: [],
}*/

const related_employee_bd = MK_YES_NO("related_employee_bd",
  "Are you related to an employee at this broker-dealer?",
    null);
const related_employee_bd_name = new Text(
  new Name("related_employee_bd_name" ,"Name"),
  null, { path: "name.name" });
const related_employee_bd_relationship = new Text(
  new Name("related_employee_bd_relationship", "Relationship"),
  null, { path: "relationship.relationship" });
/*const RELATED_GROUP = {
  yes_no: related_employee_bd,
  labels: [ related_employee_bd_name, related_employee_bd_relationship ],
}*/

const employee_another_bd = MK_YES_NO("employee_another_bd",
  "Are you an employee of a broker-dealer?");
const employee_another_bd_name = new Text(
  new Name("employee_another_bd_name", "Broker-Dealer Name"),
  null, { path: "company.companyName" });
const ANOTHER_BD_GROUP = {
  yes_no: employee_another_bd,
  labels: [employee_another_bd_name],
};

const family_employed_bd = MK_YES_NO("family_employed_bd",
  "Is a member of your immediate family employed by or affiliated"
  + " with a broker-dealer?");
const family_employed_bd_name = new Text(
  new Name("family_employed_bd_name", "Broker-Dealer Name"),
  null, { path: "company.companyName" });
const family_employed_bd_employer = new Text(
  new Name("family_employed_bd_employer", "Employee Name"),
  null, { path: "name.name" });
const family_employed_bd_relationship = new Text(
  new Name("family_employed_bd_relationship", "Relationship"),
  null, { path: "relationship.relationship" });
const FAMILY_GROUP = {
  yes_no: family_employed_bd,
  labels: [
    family_employed_bd_name,
    family_employed_bd_employer,
    family_employed_bd_relationship ],
}

const brokerage_accounts = MK_YES_NO("brokerage_accounts",
  "Are you maintaining any other brokerage accounts?");
const brokerage_accounts_name = new Text(
  new Name("brokerage_accounts_name", "Brokerage Name"),
  null, { path: "company.companyName" });
const brokerage_accounts_years_experience = new Text(
  new Name("brokerage_accounts_years_experience",
    "Years of Investment Experience"), null,
  { path: "random.num", arg0: 5, arg1: 20 });
const BROKERAGE_GROUP = {
  yes_no: brokerage_accounts,
  labels: [
    brokerage_accounts_name,
    brokerage_accounts_years_experience ]
}

const member_finra = MK_YES_NO("member_finra",
  "Are you a member/employee or related to a member/employee "
  + "of a national securities association (i.e. NYSE or FINRA)?");
const member_finra_affiliation = new Text(
  new Name("member_finra_affiliation", "Affiliation or Company Name"),
  null, { path: "company.companyName" });
const FINRA_GROUP = {
  yes_no: member_finra,
  labels: [ member_finra_affiliation ],
}

const shareholder_public_company = MK_YES_NO("shareholder_public_company",
  "Are you, or an immediate family member, a director, 10% shareholder, "
  + "policy-making officer or controlling person of a publicly traded company?");
const shareholder_public_company_name = new Text(
  new Name("shareholder_public_company_name", "Company(ies)"),
  null, { path: "company.companyName" });
const PUBLIC_GROUP = {
  yes_no: shareholder_public_company,
  labels: [ shareholder_public_company_name ],
}

const military_affiliation = MK_YES_NO("military_affiliation",
  "Are you, or anyone with an interest in this account, currently "
  + "or formerly, either (1) a senior military, governmental, or political "
  + "official, or (2) closely associated with an immediate family member "
  + "of such an official?");
const military_affiliation_text = new Text(
  new Name("military_affiliation_text",
    "Name of the official, office held and country"),
null, { path: "company.companyName" });
const MILITARY_GROUP = {
  yes_no: military_affiliation,
  labels: [ military_affiliation_text ],
}

const ALL_GROUPS = [
  //EMPLOYEE_GROUP,
  //RELATED_GROUP,
  ANOTHER_BD_GROUP,
  FAMILY_GROUP,
  BROKERAGE_GROUP,
  FINRA_GROUP,
  PUBLIC_GROUP,
  MILITARY_GROUP,
]

class BDAffiliation extends FlowRender {
  constructor(index) {
    super(index, [
      employee_bd,
      related_employee_bd,
      related_employee_bd_name,
      related_employee_bd_relationship,
      employee_another_bd,
      employee_another_bd_name,
      family_employed_bd,
      family_employed_bd_name,
      family_employed_bd_employer,
      family_employed_bd_relationship,
      brokerage_accounts,
      brokerage_accounts_name,
      brokerage_accounts_years_experience,
      member_finra,
      member_finra_affiliation,
      shareholder_public_company,
      shareholder_public_company_name,
      military_affiliation,
      military_affiliation_text,
    ]);

    this.prmList.forEach(prm => prm.onChangeCallback = this.onChange);
  }

  onChange = (component, newState) => {}

  init(componentState, appState, component) {
    super.init(componentState, appState, component);
    employee_bd.setValue(componentState, 1, true);
    related_employee_bd.setValue(componentState, 1, true);
  }

  canNavigateNext(component) {
    const highlight_rects = [];

    ALL_GROUPS.forEach(group => {
      const yes_prm = group.yes_no;
      yes_prm.isFilledElseHighlight(component.state, highlight_rects);
      const yes_clicked = yes_prm.isItemClicked(0, component.state);
      if (yes_clicked) {
        group.labels.forEach(label => {
          label.isFilledElseHighlight(component.state, highlight_rects);
        })
      }
    });

    if (highlight_rects.length > 0) {
      component.setState({ highlight_rects });
      return null;
    }
    return component.getRootUrl() + "/summary";
  }

  renderGroup = (component, group, index) => {
    const yes_no_style = {
      display: "flex",
    }
    const yes_no_prm = group.yes_no;
    const check_style = {
      float: "none",
      transform: "scale(1.2) translate(0, 0.1rem)",
      marginLeft: "0.5rem",
    }

    const labels = [];
    const yes_clicked = yes_no_prm.isItemClicked(0, component.state);

    if (yes_clicked) {
      for(let i=0; i < group.labels.length; i++) {
        const input_style = {
          width: "100%",
        }
        const group_prm = group.labels[i];
        labels.push((
          <div style={{flex: "1"}} key={i}>
            { group_prm.renderInputDiv(
              component, input_style, group_prm.name.label) }
          </div>
        ));
        if (i < group.labels.length - 1) {
          labels.push((
            <div key={i + group.labels.length} style={{ width: "1rem"}}/>
          ));
        }
      }
    }

    return (
      <div key={index}>
        <div style={yes_no_style}>
          <div style={{ flex: "1", paddingRight: "2rem"}}>
            { yes_no_prm.name.label }
          </div>
          <div>
            Yes { yes_no_prm.renderCheckbox(0, component, check_style)}
          </div>
          <div style={{marginLeft: "2rem"}}>
            No { yes_no_prm.renderCheckbox(1, component, check_style)}
          </div>
        </div>
        <div style={{ display: "flex", marginBottom: "3rem"}}>
          { labels }
        </div>
      </div>
    )
  }

  onSign = component => () => {
    component.docusign_processing = true;
    component.setState(component.state);
    component.beginSigning(CLIENT_SIGNER, true);
  }

  renderNavButtons  = component => {
    const WIDTH = "75%";
    const container_style = {
      width: WIDTH,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
    }

    const is_processing = component.docusign_processing;
    const is_navigating = component.navigating_to_docusign;
    let msg;

    if (is_processing) {
      msg = (
        <div align={"center"}>
          Generating Electronic Documents
        </div>
      )
    } else if (is_navigating) {
      msg = (
        <div align={"center"}>
          Navigating to Docusign
        </div>
      )
    }

    const show_back_button = !is_processing && !is_navigating;

    return (
      <div>
        <div style={container_style}>
          <div>
            { show_back_button && this.renderNextButton(component, null, true) }
            { !is_navigating && this.renderButton(
              component, "Sign Documents", component.docusign_processing,
              this.onSign(component))}
          </div>
        </div>
        { msg }
      </div>

    )
  }

  render = component => {

    const width = "75%";
    const section_style = {
      paddingTop: "0",
      paddingBottom: "0",
    }
    const body_container = {
      width,
      margin: "0 auto",
    }
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Company Affiliations", width) }
        { this.renderProgress(component, width) }
        <div style={{height: "2rem"}}/>
        <section className="section" style={section_style}>
          <div style={body_container}>
            { ALL_GROUPS.map(
              (group, index) => this.renderGroup(component, group, index) )}
          </div>
        </section>
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { BDAffiliation };
